<template>
	<v-card flat ref="stream" class="participant-wrapper" :class="{'has-video': track }"> 
		<InVideoControls :room="room" :local="local" 
		@pin="$emit('pin') "
		:isMain="isMain"
		v-bind="$props"
		:fullControls="fullControls"></InVideoControls>
		<div class="video-wrapper" v-if="track">
			<VideoTrack class="stream-wrapper" name="videoTrack" :track="track.track"></VideoTrack>
		</div>
		<div class="video-wrapper" v-else></div>
	</v-card>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">

	import InVideoControls from "./InVideoControls"
	import VideoTrack from "./VideoTrack"
	export default {
		name: "ParticipantCard", 
		props: {
			tracks: {},
			track: {},
			fullControls: {type: Boolean, default: true},
			isMain: {type: Boolean, default: false},
			video: {},
			audio: {},
			local: {},
			screenName: {},
			user: {}
		},
		data: () => {
			return {
			}
		},
		components: {
			InVideoControls,
			VideoTrack
		},
		methods: {
		},
		// created(){
			
		// }

	}
// </script>"